import { useEffect, useState } from 'react';

import { ToastAlertProps } from '@/components/alert/types';

export const useAlertMessage = () => {
  const [alertMessage, setAlertMessage] = useState<ToastAlertProps>({
    showNotification: false,
    message: '',
    priority: null,
  });

  useEffect(() => {
    let timer = null;
    if (alertMessage.showNotification) {
      setTimeout(() => {
        setAlertMessage({
          showNotification: false,
          message: '',
          priority: null,
        });
      }, 5000);
    }
    return () => clearTimeout(timer);
  }, [alertMessage]);

  return { alertMessage, setAlertMessage };
};
